(function(){
    'use strict'

    angular
    .module('app.contratos')
    .controller('contratos.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        ApiBaseService.remoteController = 'api/Contratos'

        const companiaId = UserInfoService.getCompaniaId();

        var vm = this;

        vm.busqueda = {
            clienteId: 0,
            proyectoId: 0,
            fechaDesde: null, 
            fechaHasta: null
        };

        vm.clientes = [];
        vm.proyectos = [];

        vm.collection = [];
        vm.title = 'Contratos';

        vm.openFechaDesde = function(){
            vm.fechaDesdeOpened = !vm.fechaDesdeOpened;
        };

        vm.openFechaHasta = function(){
            vm.fechaHastaOpened = !vm.fechaHastaOpened;
        };

        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');
        const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos', [companiaId], 'Error al obtener los proyectos.');

        vm.goToEdit = function(data){
            
            var path = '/editar-contrato/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.goToEditDetalle = function(contrato, linea){
            
            var path = '/editar-contrato-detalle/' + contrato.id;

            if(linea){
                $location.path(path + '/' + linea.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function getAll(){

            ApiBaseService.remoteController = 'api/Contratos'

            const fechaDesde = moment(vm.busqueda.fechaDesde);
            const fechaHasta = moment(vm.busqueda.fechaHasta);

            const params = [companiaId,
                vm.busqueda.clienteId,
                vm.busqueda.proyectoId,
                fechaDesde.isValid() ? fechaDesde.format('YYYY-MM-DD') : null,
                fechaHasta.isValid() ? fechaHasta.format('YYYY-MM-DD') : null];

            var promise = ApiBaseService.getAll(params);

            promise
            .then(function(collection){

                collection.forEach((c)=>{

                    let total = 0;

                    for (let index = 0; index < c.detalle.length; index++) {
                        const element = c.detalle[index];

                        total = total + (element.cantidad * element.precioUnitario);
                        
                    }
                    c.verDetalle =  false;
                    c.total = total;

                });

                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Contratos'
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.deleteDetalle = function(data){
            ApiBaseService.remoteController = 'api/Contratos/Detalle'
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){

                const item = vm.collection.find((c)=>c.id == data.contratoId);

                if(item)
                {
                    item.detalle = item.detalle.filter(function(g) {
                    return g.id !== data.id;
                    });
                }

                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        vm.clearCriteria = function()
        {
            vm.busqueda = {
                clienteId: 0,
                proyectoId: 0,
                fechaDesde: null, 
                fechaHasta: null
            }
        }

        vm.getExcel = function()
        {
            ApiBaseService.remoteController = 'api/Contratos/excel'

            const fechaDesde = moment(vm.busqueda.fechaDesde);
            const fechaHasta = moment(vm.busqueda.fechaHasta);

            const params = [companiaId,
                            vm.busqueda.clienteId,
                            vm.busqueda.proyectoId,
                            fechaDesde.isValid() ? fechaDesde.format('YYYY-MM-DD') : null,
                            fechaHasta.isValid() ? fechaHasta.format('YYYY-MM-DD') : null];
            var promise = ApiBaseService.getFile(params);

            promise
            .then(function(result){
                logger.info('Excel descargado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });        
        };

    }
})();